module.exports = __webpack_public_path__ + "media/images/ashton1-e2c263ca9c38357d58de7554fe945989.jpg";